import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { PlainTextException3c81a0qh9m2e2 as PlainTextException } from '../../../../kiteui-library/com/lightningkite/kiteui/exceptions/handling.mjs';
import { intercepted2ogpsikxxj4u0 as intercepted } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/CancellableContinuationImpl.mjs';
import {
  Companion_instancejy2056q2ma5w as Companion_instance,
  _Result___init__impl__xyqfz832zdzqrocazzs as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
} from '../../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import {
  WebAuthN_getInstance13tvuvmazia6l as WebAuthN_getInstance,
  LargeBlobResponse3ghf03dywpz5w as LargeBlobResponse,
  RequestExtensionsResponse1fuq8aaa6zp1h as RequestExtensionsResponse,
  AuthenticatorAssertionResponse3v4lwwiyr1ss4 as AuthenticatorAssertionResponse,
  AssertedPublicKeyCredentialkonu9s757pdm as AssertedPublicKeyCredential,
} from '../../../../lightning-server-sessions-shared/com/lightningkite/lightningserver/sessions/proofs/WebAuthN.mjs';
import { copyToArray2j022khrow2yi as copyToArray } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { encodeToByteArray1onwao0uakjfh as encodeToByteArray } from '../../../../kotlin-kotlin-stdlib/kotlin/text/stringJs.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var static_init_called;
function static_init() {
  if (static_init_called)
    return Unit_instance;
  static_init_called = true;
  WebAuthNMediationType_Conditional_instance = new (WebAuthNMediationType())('Conditional', 0, 'conditional');
  WebAuthNMediationType_Optional_instance = new (WebAuthNMediationType())('Optional', 1, 'optional');
  WebAuthNMediationType_Required_instance = new (WebAuthNMediationType())('Required', 2, 'required');
  WebAuthNMediationType_Silent_instance = new (WebAuthNMediationType())('Silent', 3, 'silent');
}
var WebAuthNMediationType_Conditional_instance;
var WebAuthNMediationType_Optional_instance;
var WebAuthNMediationType_Required_instance;
var WebAuthNMediationType_Silent_instance;
var WebAuthNMediationTypeClass;
function WebAuthNMediationType() {
  if (WebAuthNMediationTypeClass === VOID) {
    class $ extends Enum() {
      constructor(name, ordinal, standardName) {
        super(name, ordinal);
        this.standardName_1 = standardName;
      }
    }
    initMetadataForClass($, 'WebAuthNMediationType');
    WebAuthNMediationTypeClass = $;
  }
  return WebAuthNMediationTypeClass;
}
function WebAuthNMediationType_Conditional_getInstance() {
  static_init();
  return WebAuthNMediationType_Conditional_instance;
}
function WebAuthNMediationType_Optional_getInstance() {
  static_init();
  return WebAuthNMediationType_Optional_instance;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        this.default_1 = new (ClientAuthenticator())();
      }
      getClientAuthenticator_w0xstu_k$() {
        return this.default_1;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance() {
  if (Companion_instance_0 === VOID)
    new (Companion())();
  return Companion_instance_0;
}
function _get_webauthnAPIAvailable__10ko6u($this) {
  return window.PublicKeyCredential;
}
function asKotlinException($this, $receiver) {
  // Inline function 'kotlin.js.asDynamic' call
  var message = $receiver.message;
  return PlainTextException().new_com_lightningkite_kiteui_exceptions_PlainTextException_r8qaq2_k$(message);
}
var ClientAuthenticator$getWebAuthNCredentials$2Class;
function ClientAuthenticator$getWebAuthNCredentials$2() {
  if (ClientAuthenticator$getWebAuthNCredentials$2Class === VOID) {
    class $ {}
    initMetadataForClass($);
    ClientAuthenticator$getWebAuthNCredentials$2Class = $;
  }
  return ClientAuthenticator$getWebAuthNCredentials$2Class;
}
var ClientAuthenticator$getWebAuthNCredentials$3Class;
function ClientAuthenticator$getWebAuthNCredentials$3() {
  if (ClientAuthenticator$getWebAuthNCredentials$3Class === VOID) {
    class $ {}
    initMetadataForClass($);
    ClientAuthenticator$getWebAuthNCredentials$3Class = $;
  }
  return ClientAuthenticator$getWebAuthNCredentials$3Class;
}
var ClientAuthenticator$getWebAuthNCredentials$4Class;
function ClientAuthenticator$getWebAuthNCredentials$4() {
  if (ClientAuthenticator$getWebAuthNCredentials$4Class === VOID) {
    class $ {}
    initMetadataForClass($);
    ClientAuthenticator$getWebAuthNCredentials$4Class = $;
  }
  return ClientAuthenticator$getWebAuthNCredentials$4Class;
}
var ClientAuthenticator$getWebAuthNCredentials$5Class;
function ClientAuthenticator$getWebAuthNCredentials$5() {
  if (ClientAuthenticator$getWebAuthNCredentials$5Class === VOID) {
    class $ {}
    initMetadataForClass($);
    ClientAuthenticator$getWebAuthNCredentials$5Class = $;
  }
  return ClientAuthenticator$getWebAuthNCredentials$5Class;
}
var ClientAuthenticator$getWebAuthNCredentials$6Class;
function ClientAuthenticator$getWebAuthNCredentials$6() {
  if (ClientAuthenticator$getWebAuthNCredentials$6Class === VOID) {
    class $ {}
    initMetadataForClass($);
    ClientAuthenticator$getWebAuthNCredentials$6Class = $;
  }
  return ClientAuthenticator$getWebAuthNCredentials$6Class;
}
var ClientAuthenticatorClass;
function ClientAuthenticator() {
  if (ClientAuthenticatorClass === VOID) {
    class $ {
      constructor() {
        Companion_getInstance();
      }
      getCredentials_5t5tmi_k$() {
        return navigator.credentials;
      }
      *webAuthNAvailable_bdf5dj_k$($completion) {
        return _get_webauthnAPIAvailable__10ko6u(this);
      }
      *autofillAvailable_8yoauv_k$($completion) {
        // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
        // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
        return yield () => {
          var uCont = $completion;
          var cancellable = new (CancellableContinuationImpl())(intercepted(uCont), 1);
          cancellable.initCancellability_shqc60_k$();
          var cont = cancellable;
          var tmp = PublicKeyCredential.isConditionalMediationAvailable();
          var tmp_0 = (it) => {
            // Inline function 'kotlin.coroutines.resume' call
            var this_0 = cont;
            // Inline function 'kotlin.Companion.success' call
            var tmp$ret$5 = _Result___init__impl__xyqfz8(it);
            this_0.resumeWith_rk9gbt_k$(tmp$ret$5);
            return Unit_instance;
          };
          tmp.then(tmp_0, (it) => {
            // Inline function 'kotlin.coroutines.resume' call
            var this_0 = cont;
            // Inline function 'kotlin.Companion.success' call
            var tmp$ret$7 = _Result___init__impl__xyqfz8(false);
            this_0.resumeWith_rk9gbt_k$(tmp$ret$7);
            return Unit_instance;
          });
          return cancellable.getResult_fck196_k$();
        };
      }
      *getWebAuthNCredentials_hcy6qc_k$(request, mediation, $completion) {
        // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
        // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
        return yield () => {
          var uCont = $completion;
          var cancellable = new (CancellableContinuationImpl())(intercepted(uCont), 1);
          cancellable.initCancellability_shqc60_k$();
          var cont = cancellable;
          var controller = new AbortController();
          var options = new (ClientAuthenticator$getWebAuthNCredentials$2())();
          // Inline function 'kotlin.apply' call
          var this_0 = new (ClientAuthenticator$getWebAuthNCredentials$3())();
          // Inline function 'kotlin.collections.map' call
          var this_1 = request.allowCredentials_1;
          // Inline function 'kotlin.collections.mapTo' call
          var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_1, 10));
          var _iterator__ex2g4s = this_1.iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var item = _iterator__ex2g4s.next_20eer_k$();
            // Inline function 'kotlin.apply' call
            var this_2 = new (ClientAuthenticator$getWebAuthNCredentials$4())();
            this_2.id = WebAuthN_getInstance().base64Decoder_1.decode$default_mne14l_k$(item.id_1);
            // Inline function 'kotlin.collections.map' call
            var this_3 = item.transports_1;
            // Inline function 'kotlin.collections.mapTo' call
            var destination_0 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_3, 10));
            var _iterator__ex2g4s_0 = this_3.iterator_jk1svi_k$();
            while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
              var item_0 = _iterator__ex2g4s_0.next_20eer_k$();
              var tmp$ret$13 = item_0.standardName_1;
              destination_0.add_utx5q5_k$(tmp$ret$13);
            }
            // Inline function 'kotlin.collections.toTypedArray' call
            this_2.transports = copyToArray(destination_0);
            this_2.type = item.type_1;
            destination.add_utx5q5_k$(this_2);
          }
          // Inline function 'kotlin.collections.toTypedArray' call
          this_0.allowCredentials = copyToArray(destination);
          this_0.challenge = encodeToByteArray(request.challenge_1);
          // Inline function 'kotlin.apply' call
          var this_4 = new (ClientAuthenticator$getWebAuthNCredentials$5())();
          var tmp0_safe_receiver = request.extensions_1.appid_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.also' call
            this_4.appid = tmp0_safe_receiver;
          }
          var tmp1_safe_receiver = request.extensions_1.largeBlob_1;
          if (tmp1_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.also' call
            // Inline function 'kotlin.apply' call
            var this_5 = new (ClientAuthenticator$getWebAuthNCredentials$6())();
            this_5.read = tmp1_safe_receiver.read_1;
            var tmp0_safe_receiver_0 = tmp1_safe_receiver.write_1;
            this_5.write = tmp0_safe_receiver_0 == null ? null : encodeToByteArray(tmp0_safe_receiver_0);
            this_4.largeBlob = this_5;
          }
          this_0.extensions = this_4;
          this_0.rp = request.rpId_1;
          this_0.timeout = request.timeout_1;
          this_0.userVerification = request.userVerification_1.standardName_1;
          var publicKey = this_0;
          options.publicKey = publicKey;
          options.signal = controller.signal;
          options.mediation = mediation.standardName_1;
          var tmp = this.getCredentials_5t5tmi_k$().get(options);
          var tmp_0 = (result) => {
            // Inline function 'kotlin.js.unsafeCast' call
            var typedResponse = result.response;
            var tmp = ensureNotNull(result.id);
            var tmp0_safe_receiver = result.getClientExtensionResults();
            var tmp_0;
            if (tmp0_safe_receiver == null) {
              tmp_0 = null;
            } else {
              // Inline function 'kotlin.let' call
              var tmp_1 = tmp0_safe_receiver.appid;
              var tmp0_safe_receiver_0 = tmp0_safe_receiver.largeBlob;
              var tmp_2;
              if (tmp0_safe_receiver_0 == null) {
                tmp_2 = null;
              } else {
                // Inline function 'kotlin.let' call
                var tmp_3 = ensureNotNull(tmp0_safe_receiver_0.written);
                var tmp0_safe_receiver_1 = tmp0_safe_receiver_0.blob;
                var tmp_4;
                if (tmp0_safe_receiver_1 == null) {
                  tmp_4 = null;
                } else {
                  // Inline function 'kotlin.let' call
                  var tmp_5 = WebAuthN_getInstance().base64Encoder_1;
                  // Inline function 'kotlin.js.unsafeCast' call
                  // Inline function 'kotlin.js.asDynamic' call
                  var tmp$ret$31 = new Int8Array(tmp0_safe_receiver_1);
                  tmp_4 = tmp_5.encode$default_h4nonq_k$(tmp$ret$31);
                }
                tmp_2 = new (LargeBlobResponse())(tmp_3, tmp_4);
              }
              tmp_0 = new (RequestExtensionsResponse())(tmp_1, tmp_2);
            }
            var tmp_6 = tmp_0;
            var tmp_7 = WebAuthN_getInstance().base64Encoder_1;
            // Inline function 'kotlin.js.unsafeCast' call
            // Inline function 'kotlin.js.asDynamic' call
            var tmp$ret$33 = new Int8Array(ensureNotNull(typedResponse.authenticatorData));
            var tmp_8 = tmp_7.encode$default_h4nonq_k$(tmp$ret$33);
            var tmp_9 = WebAuthN_getInstance().base64Encoder_1;
            // Inline function 'kotlin.js.unsafeCast' call
            // Inline function 'kotlin.js.asDynamic' call
            var tmp$ret$35 = new Int8Array(ensureNotNull(typedResponse.clientDataJSON));
            var tmp_10 = tmp_9.encode$default_h4nonq_k$(tmp$ret$35);
            var tmp_11 = WebAuthN_getInstance().base64Encoder_1;
            // Inline function 'kotlin.js.unsafeCast' call
            // Inline function 'kotlin.js.asDynamic' call
            var tmp$ret$37 = new Int8Array(ensureNotNull(typedResponse.signature));
            var tmp_12 = tmp_11.encode$default_h4nonq_k$(tmp$ret$37);
            var tmp1_safe_receiver = typedResponse.userHandle;
            var tmp_13;
            if (tmp1_safe_receiver == null) {
              tmp_13 = null;
            } else {
              // Inline function 'kotlin.let' call
              var tmp_14 = WebAuthN_getInstance().base64Encoder_1;
              // Inline function 'kotlin.js.unsafeCast' call
              // Inline function 'kotlin.js.asDynamic' call
              var tmp$ret$41 = new Int8Array(tmp1_safe_receiver);
              tmp_13 = tmp_14.encode$default_h4nonq_k$(tmp$ret$41);
            }
            var output = new (AssertedPublicKeyCredential())(tmp, tmp_6, new (AuthenticatorAssertionResponse())(tmp_8, tmp_10, tmp_12, tmp_13));
            // Inline function 'kotlin.coroutines.resume' call
            var this_0 = cont;
            // Inline function 'kotlin.Companion.success' call
            var tmp$ret$44 = _Result___init__impl__xyqfz8(output);
            this_0.resumeWith_rk9gbt_k$(tmp$ret$44);
            return Unit_instance;
          };
          tmp.then(tmp_0, (error) => {
            var tmp0 = cont;
            // Inline function 'kotlin.coroutines.resumeWithException' call
            // Inline function 'kotlin.Companion.failure' call
            var exception = asKotlinException(this, error);
            var tmp$ret$46 = _Result___init__impl__xyqfz8(createFailure(exception));
            tmp0.resumeWith_rk9gbt_k$(tmp$ret$46);
            return Unit_instance;
          });
          cont.invokeOnCancellation_kffkqp_k$((it) => {
            controller.abort();
            return Unit_instance;
          });
          return cancellable.getResult_fck196_k$();
        };
      }
    }
    initMetadataForClass($, 'ClientAuthenticator', ClientAuthenticator, VOID, VOID, [0, 1, 2]);
    ClientAuthenticatorClass = $;
  }
  return ClientAuthenticatorClass;
}
//region block: exports
export {
  WebAuthNMediationType_Conditional_getInstance as WebAuthNMediationType_Conditional_getInstance1yuuoant32x,
  WebAuthNMediationType_Optional_getInstance as WebAuthNMediationType_Optional_getInstance1bk3j7584tcjj,
  Companion_getInstance as Companion_getInstancemf79zpjlrrjp,
};
//endregion

//# sourceMappingURL=webAuthN.mjs.map
